
let menuBurger = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M0 88C0 74.75 10.75 64 24 64H424C437.3 64 448 74.75 448 88C448 101.3 437.3 112 424 112H24C10.75 112 0 101.3 0 88zM0 248C0 234.7 10.75 224 24 224H424C437.3 224 448 234.7 448 248C448 261.3 437.3 272 424 272H24C10.75 272 0 261.3 0 248zM424 432H24C10.75 432 0 421.3 0 408C0 394.7 10.75 384 24 384H424C437.3 384 448 394.7 448 408C448 421.3 437.3 432 424 432z"/></svg>`




$(document).ready(function () {
  // General Message
  $('.generalmessage').prependTo('.header');

  // -------------BUTTONS AND INPUTS
  $('.ticket').text("Buy Tickets");
  $('.emailInputField input').attr('placeholder', 'ENTER EMAIL');
  $('.emailInputField input').val('')
  $('.searchBoxInput input').attr('placeholder', 'Search Website')
  $('.searchBoxInput input').val('')
  $('.emailSubmitButton').text("Get News & Deals");
  $('.mobile-nav-toggle').prepend(`${menuBurger}`)
  $('.ticket').clone().appendTo('.top-header-right').wrap('<div class="mobile-ticket-container"></div>')
  $('.rv-park').clone().appendTo('.mobile-ticket-container')
  $('.mobile-ticket-container .rv-park').addClass('mobile-rv')

  // -------------SITEINFOBANNER SETTINGS
  $('#siteInfoBannerWidget').wrap('<div class="shadow-clip"></div>')


  //Customized countdown days

  // setTimeout(() => {
  //   let infoBannerContent = $('.countdownDays').text().split(" ")[0]
  //   if (infoBannerContent === "Thanks") {
  //   } else if (infoBannerContent == "") {
  //     $('.desktop-countdown ').addClass('hideSiteInfoBar')
  //   }
  //   if ($("#body").hasClass("siteInfoBannerWidgetDateIsPast")) {
  //     $("#siteInfoBannerWidget #eventDates").addClass("hidingComponent")
  //   } else {

  //     //Words "days until" after countdays
  //     $(".countdownDays").children('').text('days until ')


  //     //Word "Only" before countdays
  //     // $(".countdownDays").prepend('Only ')
  //   }

  // }, 500)

  // -------------OVERLAY FOR LINEUPS
  let nmbrSlides = 1
  $('.featureLineupModule .featureLineupContainer').each(function () {
    $(this).find(".subContainer .featureLineupImage").prepend('<div class="overlay-lineup"></div>')
    $(this).find(".overlay-lineup").addClass(`obg${nmbrSlides++}`)
  })

  // -------------BLUE RIBBON SPONSORS HIDE CONDITION
  setTimeout(() => {
    let count = $(".blue-ribbon-sponsors-container #venue-widget .sponsorWidgetContainer .sponsorCarouselImageContainer a").children().length / 2;
    if (count <= 0) {
      $('.blue-ribbon-sponsors-container').addClass('hidingComponent')
    }

  }, 5000)

  // -------------SOCIAL SIDEBAR TARGET
  setTimeout(() => {
    $(".socialNetworks .socialNetworkIconTwitter").attr('target', '_blank');
    $(".socialNetworks .socialNetworkIconFacebook").attr('target', '_blank');
    $(".socialNetworks .socialNetworkIconYoutube").attr('target', '_blank');
    $(".socialNetworks .socialNetworkIconInstagram").attr('target', '_blank');
  }, 2000)


  // -------------FOOTER FIXED TRANSITION
  window.onscroll = function (ev) {
    if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
      $('.flex-social').addClass('height-change', 400)
    } else if ((window.innerHeight + window.pageYOffset) <= document.body.offsetHeight) {
      $('.flex-social').removeClass('height-change', 800)
    }
  };


  // -------------FOOTE MOBILE ANIMATION
  $('.mobile-nav-toggle').attr('onClick', 'addClassFooter()')
  $('.close-mobile-menu').attr('onClick', 'removeClassFooter()')


  addClassFooter = function () {
    $('footer').addClass('footer-hide')
    setTimeout(() => {
      $('footer').addClass('footer-show')
    }, 1)
  }
  removeClassFooter = function () {
    $('footer').removeClass('footer-show')
    $('footer').removeClass('footer-hide')
  }

  // BOTTOM FOOTER CONTAINER FOR MOBILE DROPDOWN======
  $('.mobile-menu-container').append(`

<footer class="footer footer-hide footer-show">
  <div class="main-footer-container">
    <div class="sign-social">
      <div class="flex-social">
        <div class="sign-container">
          <div class="left-side"></div>
          <div class="right-side"></div>
          <div class="signup-border">
            <div class="emailSignup">
              <div class="emailInputField" title="Privacy Guaranteed">
              <input placeholder="ENTER EMAIL" aria-label="Enter Email Address" id="dropdown-email">
              </div>
              <div class="emailInputSubmit">
                <a onclick="getMobileValue()" id="uc_footer_uc_footerWidgetContainer_ctl02_ctl00_ctl00_ctl00_ctl00_EmailSignup_lbtn_emailSignup" class="button inputFieldSubmit emailSubmitButton2"">Get News &amp; Deals</a>
              </div>
            </div>
          </div>
        </div>
      <div class="cloned-social"></div>
      </div>
    </div>
    <div class="cloned-maininfo"></div>
  <div class="cloned-copy"></div>
  <div class="cloned-saffire"></div>
  </div>
</footer>
`)
  $('.socialNetworks').clone().appendTo('.cloned-social')
  $('.site-copyright').clone().appendTo('.cloned-copy')
  $('.powered-by-saffire').clone().appendTo('.cloned-saffire')
  $('.main-footer-info').clone().appendTo('.cloned-maininfo')

  getMobileValue = function () {
    let email = $('#dropdown-email').val()
    $('.emailInputField input').val(email)
    $('.emailSubmitButton').click()
    $('.emailInputField input').attr('placeholder', 'ENTER EMAIL');
    $('.emailInputField input').val('')
  }
  $('.mobile-menu-header, .mobile-menu-subheader, .search-container, .mobile-menu-ticket-btn, .mobile-menu-slider, .mobile-menu-footer-links').wrapAll(`<div class="dropdown-wrap-container"></div>`)

});

$(window).load(function () {

  // Weather Script
  setInterval(function () {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (weatherBugSet || str == '') return
    $('#weatherBugWidget').addClass('weatherBugSet');
    var findSpace = str.lastIndexOf(' ');
    var stringLength = str.length;
    var res = str.substring(findSpace, stringLength);
    $('#weatherBugDescription').html(res);
    $('#weatherBugWidget').css('visibility', 'visible');
  }, 12);
});






